<template>
  <Headlins />
</template>
<script>
import appConfig from '@/app.config'
import Headlins from '../../../../components/skillup/headlines/index.vue'
export default {
  page: {
    title: 'مدیریت سرفصل ها',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-headlines-courses',
  components: {
    Headlins,
  },
}
</script>
